import { FC, HTMLAttributes } from 'react';
import { OneOrMoreReactElements } from '../../types';
import { Step, StepProps } from './Step';
import styles from './styles.module.scss';
import { StepperStatus, StepperVariant } from '../../enums';
import { joinClassNames } from '../../utils';

export type StepperProps = HTMLAttributes<HTMLUListElement> & {
  children: OneOrMoreReactElements<StepProps>;
  variant?: StepperVariant;
};

type StepperSubcomponents = {
  Step: typeof Step;
};

export const getStatus = (stepNumber: number, currentStep: number) => {
  if (stepNumber < currentStep) {
    return StepperStatus.Completed;
  }

  return stepNumber === currentStep ? StepperStatus.Active : StepperStatus.Default;
};

export const Stepper: FC<StepperProps> & StepperSubcomponents = ({
  variant = StepperVariant.Dark,
  children,
}) => (
  <ul
    className={joinClassNames(
      styles.stepper,
      variant === StepperVariant.Light ? styles.stepperLight : undefined
    )}
  >
    {children}
  </ul>
);

Stepper.Step = Step;
